var _rect, _rect2, _g, _path, _rect3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_80)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_80",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 73.3333C18.1667 73.3333 16.5978 72.6811 15.2933 71.3767C13.9867 70.07 13.3333 68.5 13.3333 66.6667V13.3333C13.3333 11.5 13.9867 9.93 15.2933 8.62334C16.5978 7.31889 18.1667 6.66667 20 6.66667H46.6667L66.6667 26.6667V66.6667C66.6667 68.5 66.0144 70.07 64.71 71.3767C63.4033 72.6811 61.8333 73.3333 60 73.3333H20ZM20 66.6667H60V30H43.3333V13.3333H20V66.6667Z",
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 36L82.7128 84H27.2872L55 36Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5_80",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 40,
    width: 44,
    height: 43
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6667,
    y: 40.2667,
    width: 42.6667,
    height: 42.6667,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4444 77.6L55 43.8222L74.5556 77.6H35.4444ZM53.2222 66.9333H56.7778V58.0444H53.2222V66.9333ZM55 72.2667C55.5037 72.2667 55.9262 72.096 56.2676 71.7547C56.6077 71.4145 56.7778 70.9926 56.7778 70.4889C56.7778 69.9852 56.6077 69.5633 56.2676 69.2231C55.9262 68.8818 55.5037 68.7111 55 68.7111C54.4963 68.7111 54.0744 68.8818 53.7342 69.2231C53.3929 69.5633 53.2222 69.9852 53.2222 70.4889C53.2222 70.9926 53.3929 71.4145 53.7342 71.7547C54.0744 72.096 54.4963 72.2667 55 72.2667ZM41.5778 74.0444H68.4222L55 50.9333L41.5778 74.0444Z",
    fill: "#1C1B1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenAttachment);
export default __webpack_public_path__ + "static/media/BrokenAttachment.e687090a9c3bf046257a4a2728b647c5.svg";
export { ForwardRef as ReactComponent };